<dx-data-grid #grid
              [allowColumnReordering]="true"
              [columnAutoWidth]="true"
              [dataSource]="remoteDataSource"
              [repaintChangesOnly]="true"
              [wordWrapEnabled]="true"
              (onInitNewRow)="onInitNewRow($event)"
              (onRowDblClick)="onRowDblClick($event)"
              (onSelectionChanged)="selectedChanged($event)"
              keyField="expenseId">
  <dxo-data-grid-selection mode="single"></dxo-data-grid-selection>
  <dxo-data-grid-grouping [autoExpandAll]="true"></dxo-data-grid-grouping>
  <dxo-data-grid-editing mode="popup">
    <dxo-data-grid-popup title="Nota Spese"
               [showTitle]="true">
    </dxo-data-grid-popup>
    <dxo-data-grid-form>
      <dxi-data-grid-item dataField="data"></dxi-data-grid-item>
      <dxi-data-grid-item dataField="importo"></dxi-data-grid-item>
      <dxi-data-grid-item dataField="expenseReasonId"></dxi-data-grid-item>
      <dxi-data-grid-item dataField="paymentTypeId"></dxi-data-grid-item>
      <dxi-data-grid-item dataField="note"
                editorType="dxTextArea"
                [colSpan]="2"
                [editorOptions]="{ height: 100 }">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="fattura"></dxi-data-grid-item>
      <dxi-data-grid-item dataField="userName"
                [visible]="false">
      </dxi-data-grid-item>
      <dxi-data-grid-item dataField="foto"></dxi-data-grid-item>
    </dxo-data-grid-form>
  </dxo-data-grid-editing>
  <dxo-data-grid-filter-row [visible]="false"></dxo-data-grid-filter-row>
  <dxo-data-grid-header-filter [visible]="true">
    <dxo-data-grid-search [enabled]="true"></dxo-data-grid-search>
  </dxo-data-grid-header-filter>
  <dxo-data-grid-search-panel [visible]="false"></dxo-data-grid-search-panel>
  <dxi-data-grid-column dataField="mese"
              dataType="date"
              sortOrder="desc"
              [format]="{ type: 'MMMM yyyy' }"
              [groupIndex]="0">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="data"
              dataType="date"
              sortOrder="desc"
              caption=""
              [width]="80"
              [format]="{ type: 'dd MMM' }">
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
    <dxi-data-grid-validation-rule type="range"
                         [min]="minDate"
                         [max]="maxDate"
                         message="La data deve essere compresa tra il mese scorso e l'anno prossimo">
    </dxi-data-grid-validation-rule>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="expenseReasonId"
              caption="Causale"
              [width]="120">
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
    <dxo-data-grid-lookup [dataSource]="expenseReasonDS"
                valueExpr="expenseReasonId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="importo"
              [width]="100">
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
    <dxo-data-grid-format type="fixedPoint" [precision]="2"></dxo-data-grid-format>
  </dxi-data-grid-column>

  <dxi-data-grid-column dataField="paymentTypeId"
              caption="Tipo Pagamento"
              [hidingPriority]="0">
    <dxi-data-grid-validation-rule type="required"></dxi-data-grid-validation-rule>
    <dxo-data-grid-lookup [dataSource]="paymentTypeDS"
                valueExpr="paymentTypeId"
                displayExpr="descrizione">
    </dxo-data-grid-lookup>
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="note"
              dataType="string"
              cellTemplate="noteTemplate"
              caption="Note"
              [hidingPriority]="2">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="fattura"
              dataType="boolean"
              caption="Fattura"
              [hidingPriority]="1">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="userName"
              dataType="string"
              [visible]="false"
              [allowEditing]="false">
  </dxi-data-grid-column>
  <dxi-data-grid-column dataField="foto"
              dataType="string"
              caption=""
              [width]="50"
              [visible]="true"
              [allowFiltering]="false"
              [allowSorting]="false"
              cellTemplate="cellTemplate"
              editCellTemplate="editCellTemplate">
  </dxi-data-grid-column>
  <dxo-data-grid-summary>
    <dxi-data-grid-group-item column="importo"
                    summaryType="sum"
                    [customizeText]="customizeTotaleImporto"
                    [showInGroupFooter]="true"
                    [alignByColumn]="true">
    </dxi-data-grid-group-item>
  </dxo-data-grid-summary>
  <div *dxTemplate="let data of 'cellTemplate'">
    @if (data.value) {
    <i class="dx-icon-photo"></i>
    }
  </div>
  <div *dxTemplate="let data of 'editCellTemplate'">
    @if (data.value  && !(data.value | checkPdfExtension)) {
    <img #uploadedImage
         class="uploadedImage"
         [src]="imageURL + data.value" />
    }
    @if (data.value | checkPdfExtension) {
    <iframe class="uploadedImage"
            [src]="getPdfURL(data.value)">
    </iframe>
    }

    <dx-file-uploader #fileUploader
                      [multiple]="false"
                      accept=".pdf,image/*"
                      uploadMode="instantly"
                      [uploadUrl]="backendURL + '/FileUpload/PostExpenses?ngsw-bypass=true'"
                      (onUploaded)="onUploaded($event, data)"
                      (onUploadError)="onUploadError($event)">
    </dx-file-uploader>
    <dx-button class="retryButton" text="Retry" [visible]="retryButtonVisible" (onClick)="onClick($event)"></dx-button>
  </div>
  <div *dxTemplate="let data of 'noteTemplate'">
    <div class="multiline-note">{{ data.value }}</div>
  </div>
  <ng-container *dxTemplate="let spesa of 'dataRowTemplateName'">
    <tr class="main-row">
      <td>{{ spesa.data.data }}</td>
      <td>{{ spesa.data.expenseReasonId }}</td>
      <td>{{ spesa.data.importo }}</td>
      <td>{{ spesa.data.paymentTypeId }}</td>
      <td>{{ spesa.data.fattura}}</td>
      <td>{{ spesa.data.foto }}</td>
    </tr>
    <tr class="notes-row">
      <td colspan="6">
        <div>{{ spesa.data.note }}</div>
      </td>
    </tr>
  </ng-container>
</dx-data-grid>
<dx-speed-dial-action icon="add"
  label="Aggiungi"
  [index]="1"
  (onClick)="addRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="trash"
  label="Cancella"
  [index]="2"
  [visible]="selectedRowIndex !== -1"
  (onClick)="deleteRow()">
</dx-speed-dial-action>
<dx-speed-dial-action icon="edit"
  label="Modifica"
  [index]="3"
  [visible]="selectedRowIndex !== -1"
  (onClick)="editRow()">
</dx-speed-dial-action>



